import React, { SyntheticEvent, useMemo } from 'react';
import { Cell, Grid } from 'styled-css-grid';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from 'mdi-react/CloseIcon';
import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon';
import get from 'lodash/get';

import { FormField, formSelector } from '@xcritical/forms';

import { Spacing } from '@crm-framework/spacing';
import { IconButton } from '@crm-framework/icon-button';
import { Label } from '@crm-framework/label';

import { promoActions } from '../actions';
import { PROMO_TYPE, PROMO_FORM_NAME } from '../consts';
import { IRulesProps } from '../types';

import { RulesInput } from './RulesInput';
import { SectionHeader } from './styled';

export const Rules: React.FC<IRulesProps> = ({ disabled }) => {
  const dispatch = useDispatch();
  const { rulesLength, type } = useSelector((state) => {
    const form = formSelector(state, PROMO_FORM_NAME);
    const $rulesLength = get(
      form,
      ['model', 'rule', 'bonusConditions'],
      []
    ).length;
    const promoType = get(form, ['model', 'type'], '');

    return {
      rulesLength: $rulesLength,
      type: promoType,
    };
  });

  const labelValue = useMemo(() => {
    switch (type) {
      case PROMO_TYPE.DEVALUATION_BONUS:
        return 'Exchange Rate';
      case PROMO_TYPE.DEPOSIT_BONUS:
        return 'Percent Of Bonus';
      case PROMO_TYPE.FIXED_BONUS:
        return 'Bonus Amount';
      default:
        return 'Amount';
    }
  }, [type]);

  const handleAddRow = (e: SyntheticEvent) => {
    e.preventDefault();
    dispatch(promoActions.addRule());
  };

  const handleRemoveRow = (index: number) => {
    dispatch(promoActions.removeRule({ index }));
  };

  return (
    <Spacing mt={20} mb={10}>
      <Grid columns="28% 28% 28% 8%" justifyContent="space-between">
        <Cell width={4}>
          <SectionHeader>
            <div>Deposits Rules</div>
            <IconButton
              withCircleHover
              icon={PlusCircleOutlineIcon}
              onClick={handleAddRow}
              disabled={disabled}
              title="Add Rule"
            />
          </SectionHeader>
        </Cell>

        <Cell>
          <Label htmlFor="percent" isRequired>
            {labelValue}
          </Label>
        </Cell>
        <Cell>
          <Label htmlFor="depositFrom" isRequired>
            Deposit Amount From
          </Label>
        </Cell>
        <Cell>
          <Label htmlFor="depositTo" isRequired>
            Deposit Amount To
          </Label>
        </Cell>
        <Cell />

        {new Array(rulesLength).fill(0).map((_: number, index: number) => (
          <>
            <Cell>
              <FormField
                id={`rule.bonusConditions.${index}.value`}
                shouldFitContainer
                name={`rule.bonusConditions.${index}.value`}
                component={RulesInput}
                rulesLength={0}
                disabled={disabled}
                errorProps={{ shouldFitContainer: false }}
              />
            </Cell>
            <Cell>
              <FormField
                id={`rule.bonusConditions.${index}.amountFrom`}
                shouldFitContainer
                name={`rule.bonusConditions.${index}.amountFrom`}
                index={index}
                rulesLength={rulesLength}
                component={RulesInput}
                disabled={disabled}
                errorProps={{ shouldFitContainer: false }}
              />
            </Cell>
            <Cell>
              <FormField
                id={`rule.bonusConditions.${index}.amountTo`}
                shouldFitContainer
                name={`rule.bonusConditions.${index}.amountTo`}
                index={index}
                rulesLength={rulesLength}
                component={RulesInput}
                disabled={disabled}
                errorProps={{ shouldFitContainer: false }}
              />
            </Cell>
            <Cell>
              {rulesLength > 1 ? (
                <IconButton
                  withCircleHover
                  icon={CloseIcon}
                  onClick={() => handleRemoveRow(index)}
                  disabled={disabled}
                />
              ) : null}
            </Cell>
          </>
        ))}
      </Grid>
    </Spacing>
  );
};
